import { useState } from "react";
import { SAVE_LABEL, type SaveAbility } from "../state/auras";

const ABILITIES: SaveAbility[] = ["str", "dex", "con", "int", "wis", "cha"];
const SHORT: Record<SaveAbility, string> = { str: "STR", dex: "DEX", con: "CON", int: "INT", wis: "WIS", cha: "CHA" };

/* A per-row control for CALLING a saving throw on demand: pick the ability and
   DC, optionally name what forces it, and announce it to the table. It lives in
   the tracker's save column so the DM can demand a save from ANY creature the
   instant it matters — not only the aura saves that fire automatically. It needs
   a live Roll20 link to announce into, so it hides when there is nowhere to call. */
export function SaveCaller({ onCall, disabled }: { onCall: (ability: SaveAbility, dc: number, reason: string) => void; disabled?: boolean }) {
  const [open, setOpen] = useState(false);
  const [ability, setAbility] = useState<SaveAbility>("dex");
  const [dc, setDc] = useState("");
  const [reason, setReason] = useState("");
  if (disabled) return null;
  if (!open) return <button className="link small save-call-open" title="Call a saving throw from this creature — announces a DC to the table in Roll20" onClick={() => setOpen(true)}>＋ call save</button>;
  const valid = Number(dc) > 0;
  const fire = () => { if (!valid) return; onCall(ability, Number(dc), reason.trim()); setOpen(false); setDc(""); setReason(""); };
  const keys = (e: { key: string }) => { if (e.key === "Enter") fire(); if (e.key === "Escape") setOpen(false); };
  return (
    <div className="save-caller" onClick={(e) => e.stopPropagation()}>
      <select value={ability} onChange={(e) => setAbility(e.target.value as SaveAbility)} aria-label="Saving throw ability" title={SAVE_LABEL[ability]}>
        {ABILITIES.map((a) => <option key={a} value={a}>{SHORT[a]}</option>)}
      </select>
      <input className="xs" type="number" value={dc} placeholder="DC" aria-label="Save DC" autoFocus onChange={(e) => setDc(e.target.value)} onKeyDown={keys} />
      <input className="save-reason" value={reason} placeholder="from… (optional)" aria-label="What forces the save" onChange={(e) => setReason(e.target.value)} onKeyDown={keys} />
      <button className="small primary" onClick={fire} disabled={!valid}>Call</button>
      <button className="ghost small" title="Cancel" onClick={() => setOpen(false)}>×</button>
    </div>
  );
}
